module.exports = __webpack_public_path__ + "static/media/video_background.30848898.mp4";